import media_utility from "./media_utility";

export default {
  props:['show_search', 'participants'],
  data () {
    return {
      participant_search: ''
    }
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    dialog: {
      get: function () {
        return this.show_search
      },
      set: function (value) {
        this.$emit('dialogClosed', value);
      }
    },
    filteredParticipants() {
      if(this.participants && this.participants && this.participants.length > 0){
        let self = this;
        let participants = this.participants;

        //Search implemented on Name, Location, Designation, Company
        if(self.participant_search){
          participants = this.participants.filter((participant)=>{
            let search_in = participant.participant_name+participant.participant_location+
              participant.participant_designation+
              participant.participant_company;
            return search_in.toLowerCase().indexOf(self.participant_search.toLowerCase())>=0;
          });
        }
        return participants;
      }
      return [];
    }
  },
  methods: {
    /*
    * group_action_dialog_open
    * */
    group_action_dialog_open(user) {
      this.$emit('group_action_dialog_open', user);
    },
    /*
    * get_user_icon
    * */
    get_user_icon(participant){
      var user = {
        user_id : participant.participant_id,
        image : participant.participant_image,
        user_name: participant.participant_name
      }
      var user_icon = media_utility.get_user_icon(user, this.user_contact_list);
      return user_icon;
    },
    /*
    * close_search
    * */
    close_search() {
      this.participant_search = '';
      this.dialog = false;
    },
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str){
      if(/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    }
  }
}
